import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './routes';
import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';



require("dotenv")

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Antd);
Vue.use(VueSweetalert2);



// const router = new VueRouter({routes});

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
